import React, { useContext, useEffect, useState, useRef } from "react";
import { Button } from "../indexComponents";
import { AuthContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faBars,
  faUser,
  faChevronDown,
  faChevronUp,
  faGear,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useUser } from "../accounts/UserProvider";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function Navbar({ onClickTeam }) {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);
  const { logout } = useUser();
  const { setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [teams, setTeams] = useState([]);
  const [showTeams, setShowTeams] = useState(false);

  // Effectue une action lorsqu'il y a un changement d'URL
  useEffect(() => {
    if (prevLocation.current !== location.pathname && onClickTeam) {
      onClickTeam();
      prevLocation.current = location.pathname;
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    logout();
    navigate("/", { replace: true });
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Récupérer tous les équipes dont l'utilisateur est membre
  const fetchTeams = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/teams`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch teams");
      }

      const data = await response.json();
      setTeams(data);
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };
  useEffect(() => {
    fetchTeams();
  }, []);

  return (
    <>
      <div
        className={`open-btn ${isMenuOpen ? "closed" : ""}`}
        onClick={toggleMenu}
      >
        <FontAwesomeIcon icon={faBars} />
      </div>
      <div className={`navbar-frame ${isMenuOpen ? "" : "closed"}`}>
        <div
          className={`close-btn ${isMenuOpen ? "" : "closed"}`}
          onClick={toggleMenu}
        >
          <Button icon={faGear} route="/settings" className="setting-btn" />
          <div className="btn-container">
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        </div>
        <Button
          route={isAuthenticated ? "/profile" : "/"}
          className="profile-btn"
          icon={faUser}
          type=""
          text="Profile"
          onClick={toggleMenu}
        />
        <Button
          route={isAuthenticated ? "/dashboard" : "/"}
          className="profile-btn"
          type=""
          text="Dashboard"
          onClick={toggleMenu}
        />

        <Button
          route={isAuthenticated ? "/active-tasks" : "/"}
          className="profile-btn"
          type=""
          text="Tâches"
          onClick={toggleMenu}
        />

        <div className="dropdown-menu">
          <Button
            route={isAuthenticated ? "/teams" : "/"}
            className="profile-btn"
            type=""
            text="Équipes"
            onClick={toggleMenu}
          />
          {showTeams ? (
            <FontAwesomeIcon
              icon={faChevronUp}
              onClick={() => {
                setShowTeams(!showTeams);
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={faChevronDown}
              onClick={() => {
                setShowTeams(!showTeams);
              }}
            />
          )}
        </div>
        {showTeams ? (
          <ul className="teams-list">
            {teams.map((team, index) => (
              <Link to={`/team/${team.id}`} key={index}>
                <li className="team-navbar">{team.name}</li>
              </Link>
            ))}
          </ul>
        ) : (
          ""
        )}
        <Button
          route={isAuthenticated ? "/clients" : "/"}
          className="profile-btn"
          type=""
          text="Clients"
          onClick={toggleMenu}
        />
        <div className="empty-space"></div>
        <Button
          text="Se déconnecter"
          onClick={handleLogout}
          className="logout-btn"
        />

        {/*           {buttonNavbar ? 
            <>
              {buttonNavbar.map((button, index) => (
                <Button key={index} route={button.route} className="btn-supplementaire" type="" text={button.text} onClick={toggleMenu}/>
              ))};
            </>
            :
            ''
          } */}
      </div>
    </>
  );
}

export default Navbar;
